const SESSION_ID_KEY = 'npeSessionId';
let fallbackSessionId: string;

// one id per browser tab; sessionStorage survives a reload so the tab keeps its NPE lock
export const getSessionId = (): string => {
    const newSessionId = () => 'tab-' + Math.random().toString(36).slice(2, 10);
    try {
        let sessionId = sessionStorage.getItem(SESSION_ID_KEY);
        if (!sessionId) {
            sessionId = newSessionId();
            sessionStorage.setItem(SESSION_ID_KEY, sessionId);
        }
        return sessionId;
    } catch {
        return fallbackSessionId ??= newSessionId();
    }
};

export const getLockReportNumber = (scope): string =>
    String(scope.report?.report_number ?? scope.vesselSpecs?.report_number);
